export const COOKIE_NAME = `_part`;
export const COOKIE_SECURED = `self-care`;
export const COOKIE_PUBLIC = `public`;
export const GA_PAGEVIEW = `gaPageview`;
export const GA_EVENT = `gaEvent`;
